export class BwMonitoringFilterCriteria {
  originPop: string;
  destinationPop: string;
  vvlanId: string;
  uniqId: string;
  dateFrom: Date;
  dateTo: Date;


  constructor(userChoicesActiveFilters) {
    this.originPop = userChoicesActiveFilters.originPop;
    this.destinationPop = userChoicesActiveFilters.destinationPop;
    this.vvlanId = userChoicesActiveFilters.vvlanId;
    this.uniqId = userChoicesActiveFilters.uniqId;
    this.dateFrom = userChoicesActiveFilters.dateFrom;
    this.dateTo = userChoicesActiveFilters.dateTo;

  }

}
